import React from "react";
import { MessagesView } from "@/components/MessagesView";
export default function ManagerMessages() { return <MessagesView />; }
